import { Action } from '@ngrx/store';

import { RouterRequestActionType } from './router-request-action-type.enum';

export class RouterRequestFulfilled implements Action {
  public readonly type: RouterRequestActionType = RouterRequestActionType.RouterRequestFulfilled;

  constructor(public readonly payload: void = undefined) { }
}
